import {useCallback, useEffect, useState} from "react";
import lscache from "lscache";

import {CODE_RESEND_DELAY_IN_SECONDS, PHONE_VERIFICATION_TIMER_START_LS_KEY} from "../../constants/phone_verification_constants";
import {getPhoneVerificationCodeRemainingTime} from "../utils/get_phone_verification_code_remaining_time";
import {shouldAutoSendPhoneVerificationCode} from "../utils/should_auto_send_phone_verification_code";

const getSavedTimerStartTime = () => {
    const savedStartTime = lscache.get(PHONE_VERIFICATION_TIMER_START_LS_KEY);

    return savedStartTime ? parseInt(savedStartTime, 10) : null;
};

// Resend cooldown persisted in localStorage, so it survives remounts and page reloads.
export const usePhoneVerificationTimer = () => {
    const [timerStartTime, setTimerStartTime] = useState<number | null>(getSavedTimerStartTime);
    const [timer, setTimer] = useState(() =>
        shouldAutoSendPhoneVerificationCode(timerStartTime) ? CODE_RESEND_DELAY_IN_SECONDS : getPhoneVerificationCodeRemainingTime(timerStartTime)
    );

    const startTimer = useCallback(() => {
        const startTime = Date.now();

        setTimerStartTime(startTime);
        setTimer(CODE_RESEND_DELAY_IN_SECONDS);
        lscache.set(PHONE_VERIFICATION_TIMER_START_LS_KEY, startTime.toString());
    }, []);

    const stopTimer = useCallback(() => {
        setTimerStartTime(null);
        setTimer(0);
        lscache.remove(PHONE_VERIFICATION_TIMER_START_LS_KEY);
    }, []);

    useEffect(() => {
        if (!timerStartTime) return;

        const interval = setInterval(() => {
            const remaining = getPhoneVerificationCodeRemainingTime(timerStartTime);

            setTimer(remaining);

            if (remaining === 0) {
                lscache.remove(PHONE_VERIFICATION_TIMER_START_LS_KEY);
                clearInterval(interval);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [timerStartTime]);

    return {startTimer, stopTimer, timer, timerStartTime};
};
import {useCallback, useEffect, useState} from "react";
import lscache from "lscache";

import {CODE_RESEND_DELAY_IN_SECONDS, PHONE_VERIFICATION_TIMER_START_LS_KEY} from "../../constants/phone_verification_constants";
import {getPhoneVerificationCodeRemainingTime} from "../utils/get_phone_verification_code_remaining_time";
import {shouldAutoSendPhoneVerificationCode} from "../utils/should_auto_send_phone_verification_code";

const getSavedTimerStartTime = () => {
    const savedStartTime = lscache.get(PHONE_VERIFICATION_TIMER_START_LS_KEY);

    return savedStartTime ? parseInt(savedStartTime, 10) : null;
};

// Resend cooldown persisted in localStorage, so it survives remounts and page reloads.
export const usePhoneVerificationTimer = () => {
    const [timerStartTime, setTimerStartTime] = useState<number | null>(getSavedTimerStartTime);
    const [timer, setTimer] = useState(() =>
        shouldAutoSendPhoneVerificationCode(timerStartTime) ? CODE_RESEND_DELAY_IN_SECONDS : getPhoneVerificationCodeRemainingTime(timerStartTime)
    );

    const startTimer = useCallback(() => {
        const startTime = Date.now();

        setTimerStartTime(startTime);
        setTimer(CODE_RESEND_DELAY_IN_SECONDS);
        lscache.set(PHONE_VERIFICATION_TIMER_START_LS_KEY, startTime.toString());
    }, []);

    const stopTimer = useCallback(() => {
        setTimerStartTime(null);
        setTimer(0);
        lscache.remove(PHONE_VERIFICATION_TIMER_START_LS_KEY);
    }, []);

    useEffect(() => {
        if (!timerStartTime) return;

        const interval = setInterval(() => {
            const remaining = getPhoneVerificationCodeRemainingTime(timerStartTime);

            setTimer(remaining);

            if (remaining === 0) {
                lscache.remove(PHONE_VERIFICATION_TIMER_START_LS_KEY);
                clearInterval(interval);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [timerStartTime]);

    return {startTimer, stopTimer, timer, timerStartTime};
};
